import HeadboardBreadcrumbsProps from "./headboard-breadcrumbs.types";

const headboardBreadcrumbsAdapter = (data: any): HeadboardBreadcrumbsProps => ({
  breadcrumb: data.migaDePan || "",
});

export default headboardBreadcrumbsAdapter;
